<template>
    <div>
      <common-table :url="url"
                    :table-columns="tableColumns"
                    :form-fields="formFields"
                    :operate="operate"
                    :permission="permission"
                    :searchs="searchs"
                    :buttons="buttons"
                    :auto-update="true"
                    ref="table">
      </common-table>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    import request from "@/utils/axios";
    import message from "@/utils/message";
    export default {
        name: "TingWuTask",
        components: {CommonTable},
        data(){
            return {
                searchs: [ {
                  name: 'agentId',
                  placeholder: '代理',
                  type: 'select',
                  selectUrl: '/agent/getAll',
                  selectData: [],
                }],
                permission:{
                    add: 'tingWuTask:add',
                    update: 'tingWuTask:update',
                    delete: 'tingWuTask:delete',
                    deleteBatch: 'tingWuTask:deleteBatch'
                },
                url: {
                    get: '/tingWuTask/listByCondition',
                    add: '/tingWuTask/add',
                    update: '/tingWuTask/update',
                    delete: '/tingWuTask/delete/',
                    delete_batch: '/tingWuTask/deleteBatch',
                  status: '/tingWuTask/status',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '100',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    width: '',
                }, {
                  field: 'liveRoomId',
                  label: '直播间ID',
                  show: true,
                  width: '',
                }, {
                    field: 'fileUrl',
                    label: '文件地址',
                    show: true,
                    width: '',
                }, {
                  field: 'language',
                  label: '文件语言',
                  show: {
                    type: 'select',
                  },
                  selectData: [{
                    id: 'cn',
                    name: '中文'
                  }, {
                    id: 'en',
                    name: '英文'
                  }],
                  width: '',
                }, {
                  field: 'taskId',
                  label: '任务id',
                  show: true,
                  width: '',
                }, {
                  field: 'transcriptionUrl',
                  label: '语音转写对应的结果url链接',
                  show: true,
                  width: '',
                }, {
                  field: 'meetingAssistance',
                  label: '智能纪要对应的结果url链接',
                  show: true,
                  width: '',
                }, {
                  field: 'autoChapters',
                  label: '章节速览功能对应的结果url链接',
                  show: true,
                  width: '',
                }, {
                  field: 'summarization',
                  label: '摘要功能对应的结果url链接',
                  show: true,
                  width: '',
                },{
                  field: 'status',
                  label: '状态',
                  show: {
                    type: 'select',
                  },
                  selectData: [{
                    id: 'ONGOING',
                    name: '任务进行中'
                  }, {
                    id: 'COMPLETED',
                    name: '任务完成'
                  },{
                    id: 'FAILED',
                    name: '任务失败'
                  }, {
                    id: 'INVALID',
                    name: '无效任务'
                  }],
                  width: '',
                },{
                  field: 'message',
                  label: '错误信息',
                  show: true,
                  width: '',
                },{
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '',
                }],
                operate: [{
                  icon: 'el-icon-refresh-left',
                  type: 'text',
                  text: '查询任务结果',
                  exist: (row) => {
                    return row.status === 'ONGOING' && this.$refs.table.havePermission('tingWuTask:getTaskInfo')
                  },
                  handle: (row) => {
                    request.post({
                      url: '/tingWuTask/getTaskInfo/' + row.id,
                      success: (data) => {
                        if (data.code == 0){
                          message.success("查询成功");
                          row.status = 0;
                        }else {
                          message.error("查询失败");
                        }
                      }
                    });
                  }
                }],
                formFields: {
                    addTitle: '添加',
                    updateTitle: '修改',
                    model: [{
                        field: 'agentId',
                        label: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择代理', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'fileUrl',
                        label: '文件地址',
                        type: 'input',
                        placeholder: '文件地址',
                        rules:[{message: '请输入文件地址', trigger: 'blur', required: true}],
                        add: true,
                        // update: true,
                    }, {
                      field: 'language',
                      label: '语言',
                      type: 'select',
                      selectData: [{
                        id: 'cn',
                        name: '中文'
                      }, {
                        id: 'en',
                        name: '英文'
                      }],
                      placeholder: '语言',
                      rules:[{message: '请输入语言', trigger: 'blur', required: true}],
                      add: true,
                      // update: true,
                    }],
                }

            }
        }
    }
</script>

<style scoped>

</style>
